import Swiper, { Navigation, Pagination, EffectFade } from 'swiper'
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import lottie from 'lottie-web'

gsap.registerPlugin(ScrollTrigger)

const magazineIndexSlider = () => {
  let animation

  const swiper1 = document.querySelector('.swiper-1')
  const swiper3 = document.querySelector('.swiper-3')
  const swiper4 = document.querySelector('.swiper-4')
  const swiper6 = document.querySelector('.swiper-6')
  const swiper8 = document.querySelector('.swiper-8')

  const magazineTrigger = document.querySelectorAll('.magazine-slider')

  const lottieCombating = document.querySelectorAll('.lottie-combating')
  const lottieAgingPets = document.querySelectorAll('.lottie-aging-pets')
  const lottieStrokeCare = document.querySelectorAll('.lottie-stroke-care')
  const lottieGrandmother = document.querySelectorAll('.lottie-grandmother-index')
  
  if (lottieCombating.length) {
    lottieCombating.forEach(item => {
      animation = lottie.loadAnimation({
        container: item,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: "/assets/BOE_22_003_health_security_teaser_230314.json"
      })
    })
  }

  if (lottieAgingPets.length) {
    lottieAgingPets.forEach(item => {
      animation = lottie.loadAnimation({
        container: item,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: "/assets/BOE_22_003_story-aging-pets_teaser_230315.json"
      })
    })
  }

  if (lottieStrokeCare.length) {
    lottieStrokeCare.forEach(item => {
      animation = lottie.loadAnimation({
        container: item,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: "/assets/BOE_22_003_story-stroke-care_teaser_230315.json"
      })
    })
  }

  if (lottieGrandmother.length) {
    lottieGrandmother.forEach(item => {
      animation = lottie.loadAnimation({
        container: item,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: "/assets/BOE_22_003_story-when-grandmothers-safe-lifes_teaser_230314.json"
      })
    })
  }

  if (magazineTrigger.length) {
    magazineTrigger.forEach(item => {      
      gsap.from(item, {
        scrollTrigger: {
          start: '400px bottom',
          trigger: item,
          toggleClass: 'active',
          once: true
        }
      })
    })
  }

  if (swiper1) {
    new Swiper('.swiper-1', {
      modules: [Navigation, Pagination, EffectFade],
      effect: 'fade',
      speed: 1000,
      navigation: {
        nextEl: '.next-1',
        prevEl: '.prev-1',
      },
      pagination: {
        el: '.dot-1',
        clickable: true,
      },
    })
  }

  if (swiper3) {
    new Swiper('.swiper-3', {
      modules: [Navigation, Pagination, EffectFade],
      effect: 'fade',
      speed: 1000,
      navigation: {
        nextEl: '.next-2',
        prevEl: '.prev-2',
      },
      pagination: {
        el: '.dot-2',
        clickable: true,
      },
    })
  }

  if (swiper4) {
    new Swiper('.swiper-4', {
      modules: [Navigation, Pagination, EffectFade],
      effect: 'fade',
      speed: 1000,
      navigation: {
        nextEl: '.next-3',
        prevEl: '.prev-3',
      },
      pagination: {
        el: '.dot-3',
        clickable: true,
      },
    })
  }

  if (swiper6) {
    new Swiper('.swiper-6', {
      modules: [Navigation, Pagination, EffectFade],
      effect: 'fade',
      speed: 1000,
      navigation: {
        nextEl: '.next-4',
        prevEl: '.prev-4',
      },
      pagination: {
        el: '.dot-4',
        clickable: true,
      },
    })
  }

  if (swiper8) {
    new Swiper('.swiper-8', {
      modules: [Navigation, Pagination, EffectFade],
      effect: 'fade',
      speed: 1000,
      navigation: {
        nextEl: '.next-5',
        prevEl: '.prev-5',
      },
      pagination: {
        el: '.dot-5',
        clickable: true,
      },
    })
  }

}

magazineIndexSlider()